<script>
    export let checkIcon = "check",
        title = "",
        checkItems = [],
        link = { text: "", href: "" };
</script>

<!--src/components/CheckList.svelte-->
<div class="checklist">
    {#if title}
        <h3>{title}</h3>
        <div class="hr"></div>
    {/if}
    <ul>
        {#each checkItems as checkItem}
            <li>
                <i class="material-icons">{checkIcon}</i>
                {checkItem}
            </li>
        {/each}
        {#if link.href}
            <li>
                <i class="material-icons material-icons-blue">more_horiz</i>
                <a href="{link.href}">{link.text}</a>
            </li>
        {/if}
    </ul>
</div>

<style>
    h3 {
        text-align: left;
        margin-top: 0px;
    }
    .checklist {
        background-color: #f4f4f4;
        box-shadow: none;
        margin: 0px auto 24px auto;
        line-height: 22px;
        padding: 24px;
        color: var(--textColorDarkest);
        border-radius: 6px;
        width: 100%;
    }

    li {
        flex: 0 0 47%;
    }
</style>
